/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SavedCommoditiesPreviewRow
 */
export interface SavedCommoditiesPreviewRow {
  /**
   *
   * @type {number}
   * @memberof SavedCommoditiesPreviewRow
   */
  rowNumber: number;
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesPreviewRow
   */
  skuIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesPreviewRow
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof SavedCommoditiesPreviewRow
   */
  status: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SavedCommoditiesPreviewRow
   */
  errors: Array<string>;
}

/**
 * Check if a given object implements the SavedCommoditiesPreviewRow interface.
 */
export function instanceOfSavedCommoditiesPreviewRow(
  value: object,
): value is SavedCommoditiesPreviewRow {
  if (!("rowNumber" in value) || value["rowNumber"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("errors" in value) || value["errors"] === undefined) return false;
  return true;
}

export function SavedCommoditiesPreviewRowFromJSON(
  json: any,
): SavedCommoditiesPreviewRow {
  return SavedCommoditiesPreviewRowFromJSONTyped(json, false);
}

export function SavedCommoditiesPreviewRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedCommoditiesPreviewRow {
  if (json == null) {
    return json;
  }
  return {
    rowNumber: json["rowNumber"],
    skuIdentifier:
      json["skuIdentifier"] == null ? undefined : json["skuIdentifier"],
    description: json["description"] == null ? undefined : json["description"],
    status: json["status"],
    errors: json["errors"],
  };
}

export function SavedCommoditiesPreviewRowToJSON(
  json: any,
): SavedCommoditiesPreviewRow {
  return SavedCommoditiesPreviewRowToJSONTyped(json, false);
}

export function SavedCommoditiesPreviewRowToJSONTyped(
  value?: SavedCommoditiesPreviewRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rowNumber: value["rowNumber"],
    skuIdentifier: value["skuIdentifier"],
    description: value["description"],
    status: value["status"],
    errors: value["errors"],
  };
}
